//SET_FILTERS

export const setLaborProcessFilters = (payload =
    {
        beginDate : '',
        endDate   : '',
        version   : ''
    }) => ({
    type : 'SET_LABOR_PROCESS_FILTERS',
    payload
});

//SET_BEGIN_DATE_FILTER
export const setBeginDateLaborProcessFilter = (beginDate) => ({
    type : 'SET_BEGIN_DATE_LABOR_PROCESS_FILTER',
    beginDate
});

//SET_END_DATE_FILTER
export const setEndDateLaborProcessFilter = (endDate) => ({
    type : 'SET_END_DATE_LABOR_PROCESS_FILTER',
    endDate
});
//SET_FORMAT_VERSION_FILTER
export const setFormatVersionLaborProcessFilter = (version) => ({
    type : 'SET_FORMAT_VERSION_LABOR_PROCESS_FILTER',
    version
});


// WEBPACK FOOTER //
// ./src/Actions/laborProcessFilters.js